import cx from 'clsx';
import React, { type ReactElement } from 'react';

import { ReactComponent as NoResultsIcon } from '@assets/svg/no-results.svg';

import style from './style.module.scss';

interface IProps {
  text: string;
  additionalText?: string;
  className?: string;
  icon?: ReactElement;
}

const TableEmptyRowExtended: React.FC<IProps> = ({ text, additionalText, className, icon }) => {
  return (
    <tr className={cx(style.emptyRow, className)}>
      <td className={style.emptyRowBlock} colSpan={30}>
        {icon || <NoResultsIcon className={style.noResultsIcon} />}
        <div className={style.emptyRowTextWrapper}>
          <span className={style.emptyRowText}>{text}</span>
          {additionalText && <span className={style.emptyRowAdditionalText}>{additionalText}</span>}
        </div>
      </td>
    </tr>
  );
};

export default TableEmptyRowExtended;
